import { useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

const StartingPrintPrice = ({ priceProfile }) => {
    const [cartCurrency, setCartCurrency] = useState();

    const queryResult = useStaticQuery(graphql`
	query {
		priceData: allAirtable(filter: {
		    table: {eq: "Price Conversions"},
		    data: {
		        Name: {
		            in: ["Print (Base)", "Special Print (Fairyland)"]
		        }
		    }
		}) {
			edges {
				node {
					data {
					    Name
						USD
						EUR
						GBP
						CAD
						AUD
					}
				}
			}
		}
	}
	`);

    let priceData;
    if (priceProfile === "Print") {
        priceData = queryResult.priceData.edges.filter(({ node }) => node.data.Name === "Print (Base)")[0].node.data;
    } else {
        priceData = queryResult.priceData.edges.filter(({ node }) => node.data.Name === priceProfile)[0].node.data;
    }

    const formattedPrice = () => {
        switch (cartCurrency) {
            case 'usd':
                return `$${priceData.USD}`;
            case 'gbp':
                return `£${priceData.GBP}`;
            case 'aud':
                return `AU$${priceData.AUD}`;
            case 'cad':
                return `Can$${priceData.CAD}`;
            case 'eur':
                return `€${priceData.EUR}`;
            default:
                return `$${priceData.USD}`;
        }
    };

    const checkForSnipcart = () => {
        if (typeof window !== 'undefined' && window.Snipcart) {
            window.Snipcart.events.on('snipcart.initialized', (snipcartState) => {
                if (cartCurrency !== snipcartState.cart.currency) {
                    if (snipcartState.cart.currency) {
                        setCartCurrency(snipcartState.cart.currency);
                    } else {
                        setCartCurrency('usd');
                    }
                }
            });
        }
    };

    checkForSnipcart();

    return formattedPrice();
};

export default StartingPrintPrice;